module.exports = __webpack_public_path__ + "static/img/bandera_azul_logo_2.3457fbeb.jpg";